module.exports = __webpack_public_path__ + "img/8.42614012.jpg";